import { useState } from 'react';
import { GIFT } from './constants';
import Table from './Table';
import TableTabs from './TableTabs';
import * as styles from './redemptionTable.module.scss';

const RedemptionTable = ({ giftCards = [] }) => {
  const [selected, setSelected] = useState(GIFT);
  const currentList = selected === GIFT ? giftCards : [];
  return (
    <section className={styles.redemptionTableContainer} data-testid="redemption-table-container">
      <section>
        <TableTabs selected={selected} setSelected={setSelected} />
      </section>
      <Table selected={selected} list={currentList} />
    </section>
  );
};

export default RedemptionTable;
